<template>
  <div class="scene-first" :class="classList">

    <MapObject class="scene-first__parking" src="/map/desktop_intro_parking.png" :animated="ready" type="trees"></MapObject>

    <MapObject class="scene-first__b0" src="/map/build_4f_long_left.png" :animated="ready" type="building" />
    <MapObject class="scene-first__b1" src="/map/build_8f_1.png" :animated="ready" type="building" />
    <MapObject class="scene-first__b2" src="/map/build_14f.png" :animated="ready" type="building" />
    <MapObject class="scene-first__b3" src="/map/build_14f_1.png" :animated="ready" type="building" />

    <MapObject class="scene-first__trees-lamps" src="/map/desktop_intro_trees.png" :animated="ready" type="trees"></MapObject>

    <MapObject class="scene-first__b4" src="/map/build_8f_1.png" :animated="ready" type="building" />
    <MapObject class="scene-first__b5" src="/map/build_8f_1.png" :animated="ready" type="building" />
    <MapObject class="scene-first__b6" src="/map/build_8f_1.png" :animated="ready" type="building" />

    <MapObject class="scene-first__stad" src="/map/stadium.png" :animated="ready" type="building"></MapObject>
    <MapObject class="scene-first__mall" src="/map/mall.png" :animated="ready" type="building"></MapObject>

    <MapObject class="scene-first__b7" src="/map/build_5f_long_1.png" :animated="ready" type="building" />
    <MapObject class="scene-first__b8" src="/map/build_14f.png" :animated="ready" type="building" />
    <MapObject class="scene-first__b9" src="/map/build_8f_1.png" :animated="ready" type="building" />

    <MapObject class="scene-first__b11" src="/map/build_8f_2.png" :animated="ready" type="building" />
    <MapObject class="scene-first__b12" src="/map/build_8f_2.png" :animated="ready" type="building" />
    <MapObject class="scene-first__b10" src="/map/build_5f_long_1.png" :animated="ready" type="building" />


  </div>
</template>

<script>
  import Scene from './Scene.vue'

  export default {
    extends: Scene,
  }
</script>

<style lang="scss">

  .scene-first {
    @include relative-units(870px, 862px, desktop)
  }


  .scene-first__b0 {
    left: 11.3%;
    top: 1.3%;
    width: 12.8%;
  }

  .scene-first__b1 {
    top: 0.2%;
    left: 58.8%;
    width: 9%;
  }

  .scene-first__b2 {
    left: 68.5%;
    top: 0.5%;
    width: 9.1%;
  }
  .scene-first__b3 {
    left: 80.7%;
    top: 2.7%;
    width: 12.3%;
  }

  .scene-first__b4 {
    top: 5.3%;
    left: 28%;
    width:10%;
  }

  .scene-first__b5 {
    left: 20%;
    top: 10.2%;
    width:10%;
  }

  .scene-first__b6 {
    left: 12.5%;
    top: 15%;
    width:10%;
  }

  .scene-first__b7 {
    left: 18.2%;
    top: 82.4%;
    width: 17%;
  }

  .scene-first__b8 {
    left: 17.4%;
    top: 49.8%;
    width:10%;
  }

  .scene-first__b9 {
    left: 7.2%;
    top: 60%;
    width:10%;
  }

  .scene-first__b10 {
    left: 82.5%;
    top: 52.6%;
    width: 16%;
  }

  .scene-first__b11 {
    left: 83.2%;
    top: 45%;
    width: 10%;
  }

  .scene-first__b12 {
    left: 75.9%;
    top: 49.5%;
    width: 10%;
  }

  .scene-first__stad {
    left: 19.1%;
    top: 17.3%;
    width: 52.9%;
  }

  .scene-first__mall {
    left: 49.8%;
    top: 61.2%;
    width: 33%;
  }

  .scene-first__trees-lamps {
    left: 2.3%;
    top: 0%;
    width: 96.4%;
  }

  .scene-first__parking {
    left: 34.6%;
    top: 16.8%;
    width: 65.2%;
  }
</style>
